// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.name .channel-name[data-v-6a5f2732] {
  position: relative;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.name .official[data-v-6a5f2732] {
  height: 14px;
  width: 14px;
  border-radius: 8px;
  background-color: var(--icon-bgcolor2);
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 10px;
  margin-left: 5px;
  flex-basis: 14px;
  min-width: 14px;
  min-height: 14px;
  overflow: hidden;
}
.btn-custom[data-v-6a5f2732] {
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-custom i.fa-window-maximize[data-v-6a5f2732] {
  font-size: inherit;
  margin-left: unset;
}
.btn-custom[data-v-6a5f2732]:hover {
  color: var(--toolbtn-color-hover);
}
.btn-custom.menu[data-v-6a5f2732] {
  width: 1.14em;
}
.btn-custom.disabled[data-v-6a5f2732] {
  cursor: initial;
  color: var(--placeholder-color);
}
.btn-custom.disabled[data-v-6a5f2732]:hover {
  fill: var(--icon-disabled-color) !important;
}
.header-channel-search[data-v-6a5f2732] {
  color: var(--toolbtn-color);
}
.header-channel-search[data-v-6a5f2732]:before {
  content: "\\F002";
  font-family: "Font Awesome 5 Pro";
  margin-top: 2px;
  margin-left: -2px;
}
.header-channel-search[data-v-6a5f2732]:hover {
  color: var(--toolbtn-color-hover) !important;
}
.header-back[data-v-6a5f2732] {
  margin-right: 12px;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/main/header/MainHeaderChannel.vue"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,kBAAkB;AACpB","sourcesContent":[".name .channel-name[data-v-6a5f2732] {\n  position: relative;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.name .official[data-v-6a5f2732] {\n  height: 14px;\n  width: 14px;\n  border-radius: 8px;\n  background-color: var(--icon-bgcolor2);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #ffffff;\n  font-size: 10px;\n  margin-left: 5px;\n  flex-basis: 14px;\n  min-width: 14px;\n  min-height: 14px;\n  overflow: hidden;\n}\n.btn-custom[data-v-6a5f2732] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.btn-custom i.fa-window-maximize[data-v-6a5f2732] {\n  font-size: inherit;\n  margin-left: unset;\n}\n.btn-custom[data-v-6a5f2732]:hover {\n  color: var(--toolbtn-color-hover);\n}\n.btn-custom.menu[data-v-6a5f2732] {\n  width: 1.14em;\n}\n.btn-custom.disabled[data-v-6a5f2732] {\n  cursor: initial;\n  color: var(--placeholder-color);\n}\n.btn-custom.disabled[data-v-6a5f2732]:hover {\n  fill: var(--icon-disabled-color) !important;\n}\n.header-channel-search[data-v-6a5f2732] {\n  color: var(--toolbtn-color);\n}\n.header-channel-search[data-v-6a5f2732]:before {\n  content: \"\\F002\";\n  font-family: \"Font Awesome 5 Pro\";\n  margin-top: 2px;\n  margin-left: -2px;\n}\n.header-channel-search[data-v-6a5f2732]:hover {\n  color: var(--toolbtn-color-hover) !important;\n}\n.header-back[data-v-6a5f2732] {\n  margin-right: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
